module.exports = __webpack_public_path__ + "img/009.9f564809.png";